'use strict';

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);
ngModule.component("topbarPrint", {
  template: require("./topbar-print.html"),
  controller: function controller($scope, $session) {
    $scope.nomClient = $session.getCompte().nomClient;
  }
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/ui/topbar/topbar-print.js
// module id = 3022
// module chunks = 13